
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbView, mdbMask, mdbInput, mdbAlert } from '@folky-tools/mdbvue';
import { usersService, businessSellingOptionsService, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessSellingOptions } from '@/models/businesses/business-selling-options';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbView,
        mdbMask,
        mdbInput,
        mdbAlert,
        FormModal: () => import('@/components/shared/FormModal.vue')
    }
})
export default class BusinessProductSellingStatusSummary extends Vue {
    @Prop(BusinessSellingOptions) private businessSellingOptions!: BusinessSellingOptions;
    @Prop({ type: Boolean, default: false }) private pageContentLoaded?: boolean;
    private businessSellingOptionsCopy: BusinessSellingOptions = new BusinessSellingOptions();
    private showModal: boolean = false;

    private showEditModal(): void {
        this.businessSellingOptionsCopy.allowSale = this.businessSellingOptions.allowSale;
        this.showModal = true;
    }

    private async saveData(): Promise<void> {
        try {
            this.businessSellingOptionsCopy.allowSale = this.businessSellingOptions.allowSale;
            await businessSellingOptionsService.updateSellingOptions(this.businessSellingOptions.businessId, this.businessSellingOptions);
            this.closeEditModal();
            notificationsService.showToastSuccessNotification('components.businesses.businessProductSellingStatusSummary.editSellingData.notifications.sellingDetailsUpdated');
            await usersService.logUserAction(new UserActionLogInfo({ type: UserActionType.HasChanged, entity: UserActionEntityType.Businesses, scope: UserActionScopeType.SellingStatus, entityId: this.businessSellingOptions.businessId }));
        } catch {
            this.closeEditModal();
            notificationsService.showToastErrorNotification();
        }
    }

    private closeEditModal(): void {
        this.businessSellingOptions.allowSale = this.businessSellingOptionsCopy.allowSale;
        this.showModal = false;
    }
}
